import { Component, OnInit, ViewEncapsulation, Input, ViewChild } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { EntityFormComponent } from 'app/components/entity-form/entity-form.component';
import { UserService } from 'app/rest/user.service';
import { Rest } from 'app/rest/rest_client';
import { NotificationsService, Severity } from 'app/services/notifications-service/notifications.service';
import { AuthenticationService } from 'app/core/services/authentication/authentication.service';
import { I18nService } from 'app/services/i18n/i18n.service';

import { BreakdownService } from 'app/modules/vehicle-inventory/services/table-management/breakdown.service';
import { InvVehicleService } from 'app/modules/vehicle-inventory/services/invVehicle.service';
import { DriverService } from 'app/modules/vehicle-inventory/services/driver.service';
import {WorkshopService} from 'app/modules/vehicle-inventory/services/table-management/workshop.service';
import { UserTimePipe } from 'app/components/shared/UserTimePipe';
import { WorkshopFormComponent } from '../../sinister/workshop/workshop-form/workshop-form.component';
import { ObservationsFormComponent } from '../../observations/observations-form/observations-form.component';
import { ObservationsListComponent } from '../../observations/observations-list/observations-list.component';
import { ProviderService } from 'app/rest/provider.service'
import { DelegationService } from 'app/modules/vehicle-inventory/services/table-management/delegation.service';
import { BreakdownReasonService } from 'app/modules/vehicle-inventory/services/table-management/breakdownReason.service';
import { BillingaccountService } from 'app/rest/billingaccount.service';


@Component({
  selector: 'app-breakdown-form',
  templateUrl: './breakdown-form.component.html',
  styleUrls: ['./breakdown-form.component.css'],
    providers:[BreakdownService, InvVehicleService, DriverService, WorkshopService, ProviderService, BillingaccountService, DelegationService, BreakdownReasonService],
  standalone: false,
})
export class BreakdownFormComponent extends EntityFormComponent<Rest.InvBreakdown> implements OnInit {

 @Input() vehicle?: Rest.Vehicle = null;
  @Input() startDate?: Date = null;
  @Input() endDate?: Date = null;

  noticeChannels: SelectItem[];
  channelsList: Rest.NoticeChannel[];
  title: string;

  active: boolean;
  ids: number[] = [];
  idsObservations: number[] = [];

  /*Permissions */
  disableSave: boolean;
  disabeChangeStatus: boolean;

  payDate: Date;
  defaultDate: Date = new Date();
  now: string;

  editVehicle: boolean;
  backupVehicle: Rest.Vehicle;
  vehiclePlaceholder: string;

  observationType: Rest.InvObservationsType = "BREAKDOWN";

  vehicleRequestContext: any;
  driverRequestContext: any;
  workshopRequestContext: any;
  providerRequestContext: any;
  billingAccountRequestContext: any;
  delegationRequestContext: any;
  breakdownReasonRequestContext: any;

  vehicleList: Rest.Vehicle[] = [];

  file: File;

  errorMessages: string[] = [];
  saving: boolean = false;
  driverList: Rest.InvDriver[] = [];

  workshopList: Rest.InvWorkshop[] = [];
  providerList: Rest.Provider[] = [];
  delegationList: Rest.Delegation[] = [];
  breakdownReasonList: Rest.InvBreakdownReason[] = [];
  billingAccountList: Rest.BillingAccount[] = [];


  startDateWorkshop: Date;
  endDateWorkshop: Date;

  formManipulation: boolean;

  @ViewChild(WorkshopFormComponent, { static: true })workshopForm: WorkshopFormComponent;
  activeTab: string = 'workshop';

// Método para cambiar de pestaña manualmente
selectTab(tabId: string) {
    this.activeTab = tabId;
}

  constructor(
    protected breakdownService: BreakdownService,
    notificationsService: NotificationsService,
    protected i18n: I18nService,
    private authenticationService: AuthenticationService,
    public translateService: TranslateService,
    public userService: UserService,
    public invVehicleService: InvVehicleService,
        public driverService: DriverService,
        public providerService: ProviderService,
        public billingAccountService: BillingaccountService,
        public delegationService: DelegationService,
        public breakdownReasonService: BreakdownReasonService,
        public workshopService: WorkshopService,
      private userTime: UserTimePipe

  ) {
    super(breakdownService, notificationsService, i18n, authenticationService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.setPermissions();
  }

  /**
   * Loads and evaluates all the necessary data before showing the form.
   *
   * @memberof TaxFormComponent
   */
  beforeShow() {
    this.errorMessages = [];
    this.errorMessages.length = 0;

    var that = this;
    this.ids = [];
    this.idsObservations = [];
    if (this.entity.documents && this.entity.documents.length > 0) {
      this.entity.documents.forEach((x) => this.ids.push(x.id));
    } else {
      this.ids = [-1];
    }

    if(this.entity.observations && this.entity.observations.length > 0){
      this.entity.observations.forEach((x) => this.idsObservations.push(x.id));
    }else{
      this.idsObservations = [-1];
    }

    if (this.vehicle) {
      this.entity.vehicle = this.vehicle;
    }

    this.editVehicle = true;

        this.driverRequestContext = {
      sortBy: 'employee.code',
      sortAsc: true,
      pageSize: 10,
      loadPermissions: false,
      filters: {},
    } as Rest.ListPaginationRequest;


    /*Permissions */
    if (this.isNew) {
      this.disableSave = false;
      if (this.vehicle !== null) {
        this.entity.vehicle = this.vehicle;
      }
      this.title = !this.vehicle
        ? this.translateService.instant('tableManagement.breakdown.createBreakdown')
        : this.vehicle.name +
          ' ' +
          this.vehicle.model?.brand?.name +
          ' - ' +
          this.vehicle.model?.name +
          ' - ' +
          this.vehicle.version?.name + 
          (this.vehicle.version ? ' (' + this.translateService.instant('tableManagement.fuelType.'+this.vehicle.version?.fuelType) + ')' : '');
      if (this.entity.vehicle) {
        this.assignParametersFromVehicle();
      }
    } else {
      this.title = !this.vehicle
        ? this.translateService.instant('tableManagement.breakdown.updateBreakdown')
        : this.vehicle.name +
          ' ' +
          this.vehicle.model?.brand?.name +
          ' - ' +
          this.vehicle.model?.name +
          ' - ' +
          this.vehicle.version?.name + 
          (this.vehicle.version ? ' (' + this.translateService.instant('tableManagement.fuelType.'+this.vehicle.version?.fuelType) + ')' : '');
      if (this.entity['_$update'] === true) {
        this.disableSave = false;
      } else {
        this.disableSave = true;
      }
      if (this.entity['_$changeStatus'] === true) {
        this.disabeChangeStatus = false;
      } else {
        this.disabeChangeStatus = true;
      }
    }


    this.startDateWorkshop = this.entity.startDateWorkshop ? this.userTime.utcToCalendarDate(this.entity.startDateWorkshop) : null;;
    this.endDateWorkshop = this.entity.endDateWorkshop ? this.userTime.utcToCalendarDate(this.entity.endDateWorkshop) : null;;
   

    
    this.vehiclePlaceholder = this.translateService.instant('general.select');
    this.vehiclePlaceholder += ' ';
    this.vehiclePlaceholder += this.translateService.instant('tableManagement.cardLists.vehicle');

    if (this.entity.vehicle !== null && this.entity.vehicle !== undefined) {
      this.vehiclePlaceholder = this.entity.vehicle.name;
    }

    if (this.vehicle !== null && this.vehicle !== undefined) {
      this.editVehicle = false;
      this.entity.vehicle = this.vehicle;
    }

    this.vehicleRequestContext = {
      sortBy: 'name',
      sortAsc: true,
      pageSize: 10,
      filters: {},
      loadPermissions: false,
    } as Rest.ListPaginationRequest;



    this.providerRequestContext = {
      sortBy: 'name',
      sortAsc: true,
      pageSize: 10,
      loadPermissions: false,
      filters: {},
  } as Rest.ListPaginationRequest;

  this.billingAccountRequestContext = {
      sortBy: 'name',
      sortAsc: true,
      pageSize: 10,
      loadPermissions: false,
      filters: {},
  } as Rest.ListPaginationRequest;

  this.delegationRequestContext = {
      sortBy: 'name',
      sortAsc: true,
      pageSize: 10,
      loadPermissions: false,
      filters: {},
  } as Rest.ListPaginationRequest;

    this.breakdownReasonRequestContext = {
      sortBy: 'reason',
      sortAsc: true,
      pageSize: 10,
      loadPermissions: false,
      filters: {},
  } as Rest.ListPaginationRequest;

  this.workshopRequestContext = {
      sortBy: 'name',
      sortAsc: true,
      pageSize: 10,
      loadPermissions: false,
      filters: {},
  } as Rest.ListPaginationRequest;



        if(this.entity.driver){
      this.driverRequestContext.filters["user"] = [this.entity.driver.employee.code + " " + this.entity.driver.employee.user.surname1 + " " + this.entity.driver.employee.user.surname2 + ", " + this.entity.driver.employee.user.name ];
    }



    if(this.entity.vehicle){
      this.vehicleRequestContext.filters["name"] = [this.entity.vehicle.name];
    }

    if(this.entity.provider){
      this.providerRequestContext.filters["name"] = [this.entity.provider.name];
    }

    if(this.entity.delegation){
      this.delegationRequestContext.filters["name"] = [this.entity.delegation.name];
    }

    if(this.entity.billingAccount){
      this.billingAccountRequestContext.filters["name"] = [this.entity.billingAccount.name];
    }

    if(this.entity.breakdownReason){
      this.breakdownReasonRequestContext.filters["reason"] = [this.entity.breakdownReason.reason];
    }

    

  if(this.entity.workshop){
    this.workshopRequestContext.filters["name"] = [this.entity.workshop.name];
  }

          this.driverService.getPage(this.driverRequestContext).then((p) => {
      this.driverList = p.entities.map((driver) => ({
        ...driver,
        formatDriverLabel: `(${driver.employee.code}) ${driver.employee.user.surname1} ${driver.employee.user.surname2}, ${driver.employee.user.name}`,
      }));
    });

    this.invVehicleService.getPage(this.vehicleRequestContext).then((p) => {
      this.vehicleList = p.entities;
    });


    this.providerService.getPage(this.providerRequestContext).then((p) => {
      this.providerList = p.entities;
    });

    this.delegationService.getPage(this.delegationRequestContext).then((p) => {
      this.delegationList = p.entities;
    });

    this.billingAccountService.getPage(this.billingAccountRequestContext).then((p) => {
      this.billingAccountList = p.entities;
    });
    
    this.breakdownReasonService.getPage(this.breakdownReasonRequestContext).then((p) => {
      this.breakdownReasonList = p.entities;
    });

  this.workshopService.getPage(this.workshopRequestContext).then((p) => {
    this.workshopList = p.entities;
  })


  }

  afterShow() {
    //  console.log("[TAXES-FORM] afterShow ***");
    //  console.log(this.entity);
  }



  onChangeVehicle(event) {
    //  console.log('+++ onChangeVehicle', event);
    this.entity.vehicle = event.value;
    this.assignParametersFromVehicle();
  }

  onFilterVehicle(event) {
    this.vehicleRequestContext = {
      sortBy: 'name',
      sortAsc: true,
      pageSize: 10,
      filters: {
        name: [event.filter ?? ''],
      },
      loadPermissions: false,
    } as unknown as Rest.ListPaginationRequest;

    this.invVehicleService.getPage(this.vehicleRequestContext).then((p) => {
      this.vehicleList = p.entities;
    });
  }

  assignParametersFromVehicle() {
    // console.log('[FINE-FORM] assignDriverFromVehicle ***');
    if (this.entity.vehicle.driver != null) {
      this.entity.driver = {
          id: this.entity.vehicle.driver.id,
          employee: this.entity.vehicle.driver.employee,
        } as Rest.InvDriver;
      var driver = this.driverList.find((d) => d.id === this.entity.vehicle.driver.id);
      if (driver) {
        this.entity.driver = driver;
      } else {
        this.driverRequestContext.filters['user'] = [this.entity.vehicle.driver.employee.code + " " + this.entity.vehicle.driver.employee.user.surname1 + " " + this.entity.vehicle.driver.employee.user.surname2 + ", " + this.entity.vehicle.driver.employee.user.name];
        this.driverService.getPage(this.driverRequestContext).then((p) => {
          this.driverList = p.entities.map((driver) => ({
            ...driver,
            formatDriverLabel: `(${driver.employee.code}) ${driver.employee.user.surname1} ${driver.employee.user.surname2}, ${driver.employee.user.name}`,
          }));
          this.entity.driver = this.driverList.find((d) => d.id === this.entity.vehicle.driver.id);
        });
      }

    }

    this.entity.billingAccount = this.entity.vehicle.billingAccount;
    this.entity.delegation = this.entity.vehicle.delegation;
    
    this.entity.provider = this.entity.vehicle.financing?.provider;
  }

  //   onFileSelected(event) {
  //     this.file = event.target.files[0];

  //     console.log('+++ ', this.file);
  //     this.TaxService.createDocument(this.entity.id, this.vehicle, this.file);
  //   }

  onKeyDownDecimal(event: any) {
    var pressedKey = event.key;
    const keyMap = new Map<number, string>();
    keyMap.set(110, ',');
    keyMap.set(190, ",");
    const { keyCode } = event;
    if (!event.target.value.includes(',') && (keyMap.has(keyCode) || pressedKey === ',')) {
      event.preventDefault();
      event.target.value += ',';
    }
  }

  validateBreakdownForm() {
    this.errorMessages = [];

    if (this.vehicle) {
      this.entity.vehicle = this.vehicle;
    }

    if (
      !this.entity.vehicle ||
      !this.entity.breakdownReason ||
      !this.entity.driver
    ) {
      this.errorMessages.push(this.translateService.instant('error.required-field.generic'));
      // this.notificationsService.add(
      // 	Severity.error,
      // 	this.translateService.instant(this.isNew ? 'general.createError' : 'updateError') + '!',
      // 	this.translateService.instant('error.required-field.generic')
      // );
      window.scroll({ top: 0, behavior: 'smooth' });
      this.saving = false;
    }
    return this.errorMessages.length === 0;
  }

  saveChanges() {
    // console.log("[TAXES-FORM] saveChanges ***");
    // console.log(this.entity);
    this.saving = true;

    this.beforeSave();
    this.entity.client = this.authenticationService.user.client;
    if (this.validateBreakdownForm()) {
      if (this.isNew) {
        // if (this.vehicle !== null) {
        // 	this.entity.vehicle = this.vehicle;
        // }


        this.breakdownService.create(this.entity).then((p) => {
          this.entity= p;
          //this.display = false;
          this.saving = false;
          this.isNew = false;
          this.breakdownService.refreshList.next({ vehicleId: this.entity.vehicle.id});
          this.return.emit(p);
        });
      } else {

        this.breakdownService.update(this.entity).then((p) => {
          this.display = false;
          this.saving = false;
          this.return.emit(p);
          this.breakdownService.refreshList.next({ vehicleId: this.entity.vehicle.id});
        });
      }
    }
  }

  protected beforeSave(): void {

    this.entity.startDateWorkshop = this.startDateWorkshop != null ? new Date(this.userTime.toUTCISOString(this.startDateWorkshop)): null;
    this.entity.endDateWorkshop = this.endDateWorkshop != null ? new Date(this.userTime.toUTCISOString(this.endDateWorkshop)): null;

  }

  refresh() {
    // console.log("[TAX-FORM] refresh");
    this.return.emit();
    //this.saveChanges();
  }

  onChangeDriver(event) {
    this.entity.driver = event.value;
  }

  onFilterDriver(event) {
    console.log(event.filter);
    this.driverRequestContext.filters['user'] = [event.filter ?? ''];
    this.driverService.getPage(this.driverRequestContext).then((p) => {
      this.driverList = p.entities.map((driver) => ({
        ...driver,
        formatDriverLabel: `(${driver.employee.code}) ${driver.employee.user.surname1} ${driver.employee.user.surname2}, ${driver.employee.user.name}`,
      }));
    });
  }

  onChangeProvider(event){
    this.entity.provider = event.value;
  }

  onFilterProvider(event){
    this.providerRequestContext.filters['name'] = [event.filter ?? ''];
    this.providerService.getPage(this.providerRequestContext).then((p) =>{
      this.providerList = p.entities;
    });
  }

  onChangeBillingAccount(event){
    this.entity.billingAccount = event.value;
  }

  onFilterRentBillingAccount(event){
    this.billingAccountRequestContext.filters['name'] = [event.filter ?? ''];
    this.billingAccountService.getPage(this.billingAccountRequestContext).then((p) =>{
      this.billingAccountList = p.entities;
    });
  }

  onChangeBreakdownReason(event){
    this.entity.breakdownReason = event.value;
  }

  onFilterBreakdownReason(event){
    this.breakdownReasonRequestContext.filters['reason'] = [event.filter ?? ''];
    this.breakdownReasonService.getPage(this.breakdownReasonRequestContext).then((p) =>{
      this.breakdownReasonList = p.entities;
    });
  }

  onChangeDelegation(event){
    this.entity.delegation = event.value;
  }

  onFilterDelegation(event){
    this.delegationRequestContext.filters['name'] = [event.filter ?? ''];
    this.delegationService.getPage(this.delegationRequestContext).then((p) =>{
      this.delegationList = p.entities;
    });
  }

  onChangeWorkshop(event){
    this.entity.workshop = event.value;
  }

  onFilterWorkshop(event){
  this.workshopRequestContext.filters['name'] = [event.filter ?? ''];
  this.workshopService.getPage(this.workshopRequestContext).then((p) =>{
    this.workshopList = p.entities;
  });
  }

  addWorkshop() {
    this.workshopForm.create();
    this.workshopForm.return.subscribe((value) => {
      
      this.workshopService.getPage(this.workshopRequestContext).then((p) => {
        this.workshopList = p.entities;
      })
    });
  }

  setPermissions() {
    const user = this.authenticationService.user;
    const rolesForForm = ['INV_BREAKDOWN_CREATE', 'INV_BREAKDOWN_UPDATE'];

    this.formManipulation = this.authenticationService.isOneRoleGranted(rolesForForm, user);
  }


}